import controller from './create.controller';
import template from './create.html';

function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.private.tickets.create', {
			controller,
			template,
			'url': '/create?subLineId&returnSubLineId&busId&date&returnDate&returnBusId&ticketType',
			'controllerAs': 'vm',
			'resolve': {
				'Discounts': function(DiscountComponent) {
					'ngInject';

					return DiscountComponent.fetchDiscounts();
				},
				'Currencies': function(CurrencyComponent) {
					'ngInject';

					return CurrencyComponent.fetchCurrencies();
				},
				'SubLine': function($state, $stateParams, SubLineComponent, Toast) {
					'ngInject';

					return SubLineComponent.fetchSubLine($stateParams.subLineId, $stateParams.busId, $stateParams.date)
						.then(function(res) {
							if (res.data && res.data.errors) {
								Toast.responseError(res.data.errors);
								$state.go('app.private.tickets.chooseSubLine');
							} else {
								return res;
							}
						});
				},
				'ReturnSubLine': function($state, $stateParams, SubLineComponent, Toast) {
					'ngInject';

					if ($stateParams.ticketType === 'return') {
						return SubLineComponent.fetchSubLine($stateParams.returnSubLineId, $stateParams.returnBusId, $stateParams.returnDate)
							.then(function(res) {
								if (res.data && res.data.errors) {
									Toast.responseError(res.data.errors);
									$state.go('app.private.tickets.chooseSubLine');
								} else {
									return res;
								}
							});
					} else {
						return {};
					}
				}
			}
		});
}

export default RouteConfig;



/** WEBPACK FOOTER **
 ** ./client/private/tickets/create/create.route.js
 **/